var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcDiners = function SvgCcDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M19.045 19.5c3.897.019 7.455-3.208 7.455-7.133 0-4.292-3.558-7.26-7.455-7.258h-3.354C11.747 5.108 8.5 8.076 8.5 12.367c0 3.926 3.247 7.152 7.19 7.133h3.355Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.707 5.704c-3.605.001-6.525 2.95-6.526 6.587.001 3.639 2.921 6.586 6.526 6.588 3.604-.002 6.526-2.95 6.526-6.588s-2.921-6.586-6.526-6.587Zm-4.137 6.587a4.18 4.18 0 0 1 2.656-3.896v7.792a4.179 4.179 0 0 1-2.656-3.896Zm5.617 3.898V8.395a4.179 4.179 0 0 1 2.657 3.897 4.18 4.18 0 0 1-2.657 3.897Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M19.045 19.5c3.897.019 7.455-3.208 7.455-7.133 0-4.292-3.558-7.26-7.455-7.258h-3.354C11.747 5.108 8.5 8.076 8.5 12.367c0 3.926 3.247 7.152 7.19 7.133h3.355Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.707 5.704c-3.605.001-6.525 2.95-6.526 6.587.001 3.639 2.921 6.586 6.526 6.588 3.604-.002 6.526-2.95 6.526-6.588s-2.921-6.586-6.526-6.587Zm-4.137 6.587a4.18 4.18 0 0 1 2.656-3.896v7.792a4.179 4.179 0 0 1-2.656-3.896Zm5.617 3.898V8.395a4.179 4.179 0 0 1 2.657 3.897 4.18 4.18 0 0 1-2.657 3.897Z"
  })));
};
export default SvgCcDiners;